/* eslint jsx-a11y/href-no-hash: "off" */

import React from "react";
import { isNameValid } from "../battle-optin/optin-utilities.js";
import audioManager from "../_audio/audio-manager.js";
import {getSafeCombatantName} from '../b5-crew-management/edit-combatant-operations.js'

class OnboardingScreenGetName extends React.Component {
  constructor() {
    super();
    this.state = {
      isShowingForm: false,
      isShowingErrors: false,
      showingCompletedName: null
    };
  }

  componentWillMount() {
    setTimeout(() => {
      this.setState({ isShowingForm: true });
      audioManager.playSfx("sfx_popup");
    }, 600);
  }

  handleSubmitButton(e) {
    e.preventDefault();
    this.handleNameSubmit();
  }

  capAt10Chars() {
    //If iOS pastes in a name that thrawrts maxLength, just shorten it here.
    this.refs.name.value = this.refs.name.value.substr(0,9)
  }

  handleNameSubmit(e) {
    if (e) {
      e.preventDefault();
    }

    let newValue = this.refs.name.value;

    //validate it for length
    if (isNameValid(newValue)) {

      //Run through safe check for weird characters
      newValue = getSafeCombatantName(newValue);

      //valid length!
      this.setState({
        showingCompletedName: newValue,
        isShowingErrors: false
      });

      //SFX: "success"
      audioManager.playSfx("sfx_submitAction");

      //Wait a second for effect, then proceed
      setTimeout(() => {
        this.props.onNameReceived(newValue);
      }, 1000);
    } else {
      //Invalid - show errors
      this.setState({ isShowingErrors: true });
    }
  }

  renderSubmitButton() {
    if (this.state.showingCompletedName) {
      return null;
    }

    return (
      <a
        href="#"
        className={`button block large primary`}
        onClick={this.handleSubmitButton.bind(this)}
      >
        <span className="button--text">Let's Go!</span>
      </a>
    );
  }

  renderInputArea() {
    //If we've submitted, show just the name for a second.
    if (this.state.showingCompletedName) {
      const style = {
        fontSize: "1.8em",
        textAlign: "center"
      };
      return (
        <div style={style}>
          {this.state.showingCompletedName}!
        </div>
      );
    }




    //Default to the form field
    return (
      <input
        onChange={this.capAt10Chars.bind(this)}
        className="NameTextInput"
        style={{width: "100%"}}
        id="onboarding-name-input"
        ref="name"
        type="text"
        maxLength={9}
        autoFocus={true}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
      />
    );
  }

  renderForm() {
    const overlayStyle = {
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
      background: "rgba(255,255,255,0.95)",
      zIndex: 4,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      padding: "2em"
    };

    const modalStyle = {
      padding: "3em",
      background: "#FCFCFC",
      outline: "0.5em solid #1F0535",
      margin: "0 auto",
      width: "100%",
      zIndex: "1",
      position: "relative",
      maxWidth: this.props.viewportMode === "landscape" ? "33em" : "100%" //desktop, mobile
    };

    const labelStyle = {
      textAlign: "center",
      display: "block",
      fontSize: "1em",
      marginBottom: "3em"
    };

    const ctaContainerStyle = {
      marginTop: "3em"
    };

    const errorStyle = {
      textAlign: "center",
      marginTop: "3em",
      color: "red"
    };

    //If we haven't submitted yet, show a form:
    return (
      <div style={overlayStyle}>
        <div style={modalStyle}>
          <form ref="form" onSubmit={this.handleNameSubmit.bind(this)}>
            <label style={labelStyle} htmlFor="onboarding-name-input">
              What's your name?
            </label>

            {this.renderInputArea()}

            {this.state.isShowingErrors
              ? <div style={errorStyle}>Please enter a valid name.</div>
              : null}
            <div style={ctaContainerStyle}>
              {this.renderSubmitButton()}
            </div>
          </form>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {/*<TextLine*/}
        {/*lineData={this.props.text}*/}
        {/*onDone={this.handleReadyForName.bind(this)}*/}
        {/*/>*/}

        {/* Show form if textLine is ready */}
        {this.state.isShowingForm ? this.renderForm() : null}
      </div>
    );
  }
}

export default OnboardingScreenGetName;



// WEBPACK FOOTER //
// ./src/b5-onboarding/OnboardingScreenGetName.js